__turbopack_context__.v({
  "chartCard": "UserReferralsOverTimeChart-module__quD_TG__chartCard",
  "chartWrapper": "UserReferralsOverTimeChart-module__quD_TG__chartWrapper",
  "errorText": "UserReferralsOverTimeChart-module__quD_TG__errorText",
  "loadingText": "UserReferralsOverTimeChart-module__quD_TG__loadingText",
  "noDataText": "UserReferralsOverTimeChart-module__quD_TG__noDataText",
});
